<template>
    <el-row class="container_self table_parent">
     <h3>链接列表</h3>
     <el-row class="add_btn"><el-button type="success" icon="el-icon-plus" size="mini" @click="addUrl">新增链接</el-button></el-row>
     <el-table :data="urlList" v-loading="loading"  element-loading-text="加载中，请稍后">
       <el-table-column label="ID" prop="id" align="center" width="50px"></el-table-column>
       <el-table-column label="渠道ID" prop="channelId" align="center"></el-table-column>
       <el-table-column label="链接" prop="webUrl" align="center"></el-table-column>
       <el-table-column label="是否启用" align="center">
         <template slot-scope="scope">
             <span v-if="scope.row.enabled">是</span><span v-else>否</span>
          </template>
       </el-table-column>
       <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
       <el-table-column label="操作" align="center">
          <template slot-scope="scope">
             <el-button size="mini" type="primary" @click="updateUrl(scope.row)">更新</el-button>
             <el-button size="mini" type="danger" @click="deleteUrl(scope.row.id)">删除</el-button>
          </template>
       </el-table-column>
     </el-table>
     <el-pagination
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         :current-page="searchForm.currentPage"
         :page-sizes="[20, 50, 100, 200]"
         :page-size="searchForm.pageSize"
         layout="total, sizes, prev, pager, next, jumper"
         :total="total">
      </el-pagination>
 
 
     <el-dialog :title="string+'链接'" :visible.sync="dialogFormVisible">
             <el-form :model="addUrlForm" :rules="rules" ref="ruleForm">
                 <el-form-item label="渠道ID" :label-width="formLabelWidth" prop="channelId">
                     <!-- <el-input v-model="addUrlForm.channelId" autocomplete="off" placeholder="请输入链接ID"></el-input> -->
                     <el-select v-model="addUrlForm.channelId" remote reserve-keyword filterable placeholder="请输入渠道ID" :remote-method="searchChannel" style="width:100%">
                        <el-option
                            v-for="item in channelList"
                            :key="item.id"
                            :label="item.channelId"
                            :value="item.channelId">
                        </el-option>
                    </el-select>
                 </el-form-item>
                 <el-form-item label="链接" :label-width="formLabelWidth" prop="webUrl">
                     <el-input v-model="addUrlForm.webUrl" autocomplete="off" placeholder="请输入链接名称"></el-input>
                 </el-form-item>
                 <el-form-item label="是否启用" :label-width="formLabelWidth">
                    <el-select v-model="addUrlForm.enabled" placeholder="请选择是否启用此链接" clearable>
                         <el-option :value="1" label="启用"></el-option>
                         <el-option :value="0" label="不启用"></el-option>
                    </el-select>
                 </el-form-item>
             </el-form>
             <div slot="footer" class="dialog-footer">
                 <el-button @click="dialogFormVisible = false">取 消</el-button>
                 <el-button type="primary" @click="submitChannel('ruleForm')">确 定</el-button>
             </div>
      </el-dialog>
    </el-row>
 </template>
 
<script>
import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    export default {
       data(){
          return{
             urlList:[],
             searchForm:{
                currentPage:1,
                enabled:"",
                keyword:"",
                pageSize:20
             },
             total:0,
             dialogFormVisible:false,
             addUrlForm:{
               "channelId": "",
               "enabled": 1,
               "webUrl": ""
             },
             formLabelWidth:"120px",
             string:"新增",
             rules:{
                channelId: [
                   { required: true, message: '请输入链接ID', trigger: 'blur' },
                ],
                webUrl:[
                   { required: true, message: '请输入链接名称', trigger: 'blur' }
                ]
             },
             isEdit:false,
             channelList:[],
             loading:false,
          }
       },
       methods:{
         handleSizeChange(val){
            this.searchForm.pageSize=val;
            this.geturlList(this.searchForm)
         },
         handleCurrentChange(val){
            this.searchForm.currentPage=val;
            this.geturlList(this.searchForm)
         },
          geturlList(params){
            this.loading=true;
             axiosGet('/api/channel/list_url',params).then(res=>{
                if(res.code==0){
                  this.loading=false;
                   this.total=res.data.total;
                   this.urlList=res.data.records;
                }else{
                  this.loading=false;
                }
             })
          },
          getChannelList(params){
            axiosGet('/api/channel/list',params).then(res=>{
               if(res.code==0){
                  this.total=res.data.total;
                  this.channelList=res.data.records;
               }
            })
          },
          searchChannel(keyword){
            if(keyword){
               this.getChannelList({currentPage:1,pageSize:20,keyword:keyword})
            }
          },
          choseChannel(){

          },
          deleteUrl(id){
             this.$confirm('此操作将永久删除该链接是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
             }).then(() => {
                axiosPost('/api/channel/delete_url',{id:id},'JSON').then(res=>{
                   if(res.code==0){
                      this.$message({message:'链接删除成功',type:'success'});
                      this.geturlList(this.searchForm);
                   }
                })
             }).catch(() => {});
          },
          addUrl(){
             this.dialogFormVisible=true;
             this.string="新增";
             this.isEdit=false;
             this.addUrlForm={
               "channelId": "",
               "enabled": 1,
               "webUrl": ""
             }
          },
          submitChannel(formName){
             this.$refs[formName].validate((valid) => {
                if (valid) {
                   const url = this.isEdit ? '/api/channel/update_url' : '/api/channel/add_url';
                   axiosPost(url, this.addUrlForm, 'JSON').then(res => {
                         if (res.code === 0) {
                            const message = this.isEdit ? '链接更新成功' : '链接新增成功';
                            this.$message({ message: message, type: 'success' });
                            this.dialogFormVisible = false;
                            this.geturlList(this.searchForm);
                         }
                   });
                }
             });
          },
          updateUrl(row){
             this.string="更新";
             this.isEdit=true;
             let editForm={
                channelId:row.channelId,
                enabled:row.enabled,
                webUrl:row.webUrl,
                id:row.id
             }
             this.addUrlForm=editForm;
             this.dialogFormVisible=true;
          }
       },
       mounted(){
          this.geturlList(this.searchForm);
       }
    }
</script>


// WEBPACK FOOTER //
// src/components/view/AppManager/urlList.vue